var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h3", { staticClass: "_header" }, [_vm._v("修复录入")]),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "refForm",
          attrs: {
            model: _vm.form,
            "label-position": "left",
            "label-width": "80px",
            rules: _vm.formRules
          }
        },
        [
          _c(
            "el-form-item",
            {
              staticStyle: { width: "380px" },
              attrs: { label: "XF号: ", prop: "qc" }
            },
            [
              _c("el-input", {
                model: {
                  value: _vm.form.qc,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "qc", $$v)
                  },
                  expression: "form.qc"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              staticStyle: { width: "380px" },
              attrs: { label: "打标id: ", prop: "re_dbids" }
            },
            [
              _c("el-input", {
                staticStyle: { width: "300px" },
                attrs: { type: "number", controls: false },
                nativeOn: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.formatDbid.apply(null, arguments)
                  }
                },
                model: {
                  value: _vm.dbid_str,
                  callback: function($$v) {
                    _vm.dbid_str = $$v
                  },
                  expression: "dbid_str"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            _vm._l(_vm.form.re_dbids, function(item) {
              return _c(
                "el-tag",
                {
                  key: item,
                  staticStyle: { "margin-right": "10px" },
                  attrs: { closable: "", hit: true, type: "success" },
                  on: {
                    close: function($event) {
                      return _vm.handleClose(item)
                    }
                  }
                },
                [_vm._v(_vm._s(item))]
              )
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submit } },
                [_vm._v("提交")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-eff96ff8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eff96ff8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/quality/Check.vue
// module id = null
// module chunks = 